var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component)?_c(_vm.component,_vm._g({tag:"component",staticClass:"h-100",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }